import TextArea from "../../../../Components/Common/TextArea/TextArea";
import { CHAR_LIMIT } from "../../../../utils/Common/Constant";
import { useEffect, useState } from "react";
import DateSelect from "Components/Common/DateSelect/DateSelect";
import Input from "Components/Common/Input/Input";

interface FormFieldProps {
  label: string;
  required?: boolean;
  auto?: boolean;
  type?: string;
  value?: string;
  onChange?: (val: string) => void;
  placeholder?: string;
  as?: "input" | "textarea";
  className?: string;
  rows?: number;
  icon?: string;
  otherProps?: Record<string, any>;
  error?: string;
}

const FormField = ({
  label,
  required = false,
  auto = false,
  type = "text",
  value,
  onChange,
  placeholder,
  as = "input",
  className = "",
  rows = 4,
  icon,
  otherProps,
  error,
}: FormFieldProps) => {
  const [dateVal, setDateVal] = useState(value || "");

  useEffect(() => {
    if (value !== undefined) setDateVal(value);
  }, [value]);

  return (
    <div className="craField">
      <label>
        {label}
        {required ? <span className="req">*</span> : null}
        {auto ? <span className="auto">●</span> : null}
      </label>
      {as === "textarea" ? (
        onChange ? (
          <TextArea
            rows={rows}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={`${className}${error ? " error-input-red" : ""}`}
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
        ) : (
          <TextArea
            rows={rows}
            defaultValue={value}
            placeholder={placeholder}
            className={`${className}${error ? " error-input-red" : ""}`}
            readOnly={auto}
              maxChars={CHAR_LIMIT.DESCRIPTION}
            />
        )
      ) : type === "date" ? (
        <DateSelect
          value={dateVal}
          onChange={(v) => { setDateVal(v); onChange?.(v); }}
          disabled={auto}
          error={!!error}
        />
      ) : onChange ? (
        <div className={icon ? "inputIconWrap" : undefined}>
          {icon && <p className="inputIcon">{icon}</p>}
          <Input
            type={type}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={`${className}${error ? " error-input-red" : ""}`}
            {...otherProps}
          />
        </div>
      ) : (
        <div className={icon ? "inputIconWrap" : undefined}>
          {icon && <p className="inputIcon">{icon}</p>}
          <Input
            type={type}
            defaultValue={value}
            placeholder={placeholder}
            className={`${className}${error ? " error-input-red" : ""}`}
            readOnly={auto}
            {...otherProps}
          />
        </div>
      )}
      {error && <p className="field-error">{error}</p>}
    </div>
  );
};

export default FormField;
